import React from "react";
import { Box, BoxProps } from "@UI/Components/Box/Box";
import { Image } from "@UI/Components/Image/Image";
import { Checkbox } from "@UI/Components/Checkbox/Checkbox";

interface IPhotoBookItemProps extends BoxProps {
  url: string;
  isChecked?: boolean;
  onSelect?: () => void;
}
export const PhotoBookItem = (props: IPhotoBookItemProps) => {
  const {
    onSelect,
    url,
    isChecked = false,
    ...rest
  } = props;

  return (
    <Box position="relative" {...rest}>
      <Image
        src={url}
        alt="Photo"
        boxSize="inherit"
        border={`${isChecked ? "3" : "1"}px solid`}
        borderColor={isChecked ? "seaGreen" : "gray.200"}
        borderRadius="10px"
        objectFit="cover"
        onClick={onSelect}
      />
      <Checkbox
        size="lg"
        backgroundColor="white"
        borderRadius={"7px"}
        position="absolute"
        top="8px"
        right="8px"
        name="delete_photo_checkbox"
        colorScheme="seaGreen"
        isChecked={isChecked}
        onChange={onSelect}
      />
    </Box>
  );
};
